<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.grupoExame"
                    :search-fields="fields.grupo"
                    :validations="validations.grupo"
                    label="Grupo de exame"
                    text-field="nome"
                    uppercase
                    v-model="model.grupo"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                grupo: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            grupo: [
                { key: 'grupo.nome', searchable: true },
            ],
        },
        model: {
            grupo: null,
        },
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.data.model.dataDesejadaGruposExames.some(g => g.id === this.model.grupo.id)) {

                        this.showAlert('Grupo de exame já existente.', 'Atenção')

                        return;
                    }

                    this.data.model.dataDesejadaGruposExames.push(this.prepareData())

                    this.$emit('save')
                })
        },
        prepareData() {

            return {
                id: this.model.grupo.id,
                codigo: this.model.grupo.codigo,
                nome: this.model.grupo.nome,
            }
        }
    },
    mixins: [repository, object],
    props: {
        data: { type: Object, required: true },
    },
}
</script>